import axios from 'axios';
import { mvxApiUrl, collectionId } from '../config';
import { NFT, NFTList } from '../types/nft';


export const getNFTs = async (address: string): Promise<NFTList> => {
    try {
        const all: NFT[] = [];
        const pageSize = 100;
        let from = 0;

        while (true) {
            const response = await axios.get(
                `${mvxApiUrl}/accounts/${address}/nfts`,
                {
                    params: {
                        collections: collectionId,
                        from,
                        size: pageSize,
                    },
                }
            );

            const batch: NFT[] = response.data.map((nft: any) => ({
                identifier: nft.identifier,
                collection: nft.collection,
                attributes: nft.attributes,
                media: nft.media.map((m: any) => ({
                    thumbnailUrl: m.thumbnailUrl || m.url,
                })),
            }));

            all.push(...batch);

            if (response.data.length < pageSize) {
                break;
            }
            from += pageSize;
        }

        return { nfts: all };
    } catch (error) {
        console.error('Error fetching NFTs:', error);
        return { nfts: [] };
    }
};
